// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Ywia","cell":"ColumnAccessor_cell__3YU8p","firstCellAccent":"ColumnAccessor_firstCellAccent__25RHj"};